const RECENT_SEARCHES_KEY = 'boostPFSRecentSearches';

/**
 * Get recent searches data on click
 * @type {import('./index').getOnClickRecentSearches}
 */
const getOnClickRecentSearches = (maxRecentSearch = 10) => {
  let recentSearches;
  try {
    const value = localStorage.getItem(RECENT_SEARCHES_KEY);
    recentSearches = value && JSON.parse(value);
  } catch {
    recentSearches = [];
  }

  if (!Array.isArray(recentSearches)) {
    recentSearches = [];
  } else {
    if (maxRecentSearch > 0) {
      recentSearches = recentSearches.slice(0, maxRecentSearch);
    }
  }
  const filterRecentSearches = [];
  recentSearches.forEach((recentSearch) => {
    if (recentSearch.title !== '') {
      filterRecentSearches.push(recentSearch);
    }
  });

  return filterRecentSearches;
};

/**
 * Set recent searches data
 * @type {import('./index').setOnClickRecentSearches}
 */
const setOnClickRecentSearches = (item, extraParam = '', scope = '') => {
  // Get current recent searches
  if (typeof item != 'string' || item.trim() === '') return;
  item = item.trim();
  let recentSearches = getOnClickRecentSearches();
  const maxInLocalStorage = 10;

  // Add or move the new search to top
  const index = recentSearches.findIndex(
    (recentSearch) => recentSearch.title === item && recentSearch.extraParam === extraParam
  );
  if (index >= 0) {
    recentSearches.splice(index, 1);
    recentSearches.unshift({ title: item, extraParam, scope });
  } else {
    recentSearches.unshift({ title: item, extraParam, scope });
    recentSearches = recentSearches.slice(0, maxInLocalStorage);
  }
  // Set storage
  try {
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(recentSearches));
  } catch {}
};

/**
 *  Handles click events on suggestion terms and popular searches
 * Extracts the search term from clicked elements and saves it to recent searches
 * @type {import('./index').handleRecentSearchForSuggestionTerm}
 */
const handleRecentSearchForSuggestionTerm = (event) => {
  if (!event || !event.target) return;
  const target = event.target;
  const clickPopularSuggestion = target?.closest('.boost-sd__suggestion-queries-item--suggestion');
  const clickPopularSearch = target?.closest('.boost-sd__no-search-result-page-suggestion-item');

  if (clickPopularSuggestion) {
    const searchTerm = clickPopularSuggestion
      ?.querySelector('.boost-sd__suggestion-queries-link')
      ?.innerText?.trim();

    if (searchTerm) {
      setOnClickRecentSearches(searchTerm);
    }
  }

  if (clickPopularSearch) {
    const term = clickPopularSearch?.innerText?.trim();
    if (term) {
      const encodedTerm = encodeURIComponent(term);
      clickPopularSearch.setAttribute('href', `/search?q=${encodedTerm}`);
      setOnClickRecentSearches(term);
    }
  }
};

export { getOnClickRecentSearches, handleRecentSearchForSuggestionTerm, setOnClickRecentSearches };
